<template>
  <div class="confirm-form">
    <div class="form-group">
      <h6 class="text-center" for="amount">最大庫存</h6>
      <input class="form-control custom-input" ref="input" id="amount" type="number" v-model="amount" min="0" @click="showPad = true">
      <transition name="fade"> 
        <NumberInput v-if="showPad" v-on:saveNumber="saveNumber" :defaultNumber="amount"/>
      </transition>
    </div>
    <div class="form-group">
      <h6 class="text-center" for="patch">批號</h6>
      <input class="form-control custom-input" id="patchnumber" :placeholder="placeholderText" v-model="patchNumber">
    </div>
    <div class="button-wrap">
      <button class="btn btn-lg confirm-button" @click="setMaxAmountData">確認</button>
    </div>
    
  </div>  
</template>

<script>
import NumberInput from './NumberInput';

export default {
  name: 'confirmMaxStock',
  components: {
    NumberInput,
  },
  data() {
    return {
      amount: 0,
      patchNumber: '',
      // amountData: {
      //   amount: 0,
      //   patchNumber: '',
      // },
      showPad: false,
    };
  },
  computed: {
    drug() {
      return this.$store.state.drug.selectedDrug;
    },
    placeholderText() {
      if (this.drug.restrained_class > 0) return '此藥物為管制藥物，請輸入批號';
      return '選填批號';
    },
  },
  mounted() {
    this.$refs.input.focus();
  },
  methods: {
    setMaxAmountData() {
      if (this.amount === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '最大庫存不可為0' });
      } else {
        if (this.drug.restrained_class > 0) {
          if (this.patchNumber === '') {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '新增管制藥物，請設定批號' });
          } else {
            this.$emit('setMaxAmountData', { amount: this.amount, patchNumber: this.patchNumber });
          }
        } else {
          this.$emit('setMaxAmountData', { amount: this.amount, patchNumber: this.patchNumber });
        }
      }
    },
    saveNumber(val) {
      this.showPad = false;
      this.amount = val;
    },
  },
  watch: {
    amount(val) {
      console.log(val);
      if (isNaN(val)) {
        this.amount = 0;
      } else {
        this.amount = parseInt(this.amount, 10);
      }
    },
  },
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// MaxStockSet.vue?cb0ade92